import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import LoadingModal from 'setup-guide-components/components/modal/base/LoadingModal';
export const ActivationSuccessModalContainerWrapper = Loadable({
  LoadingComponent: LoadingModal,
  loader: () => import( /* webpackChunkName: "ActivationSuccessModalContainer" */'./ActivationSuccessModalContainer')
});